import { render, staticRenderFns } from "./WarningCircular.vue?vue&type=template&id=52470b06&scoped=true&"
import script from "./WarningCircular.vue?vue&type=script&lang=js&"
export * from "./WarningCircular.vue?vue&type=script&lang=js&"
import style0 from "./WarningCircular.vue?vue&type=style&index=0&id=52470b06&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52470b06",
  null
  
)

export default component.exports